
import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setFilials(state, payload) {
    state.filials = payload
  },
  setInitialState() {
    this.state.fit = {
      ...initialState()
    }
  }
}

export default mutations